module.exports = __webpack_public_path__ + "static/media/cream-city-sponsors.d19a7354.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cream-city-sponsors.jpg
// module id = 1521
// module chunks = 0